// Member relationship within a circle (Owner / Dad / Mom ...), mirrored from
// the mobile app's relationship_service. There is no backend column for this
// yet, so - like the mobile app's prefs - it is stored locally for the current
// user (per browser). Swap to the API once a relationship field exists.

export const RELATIONSHIPS = [
    {id: "owner", label: "Me (Owner)"},
    {id: "dad", label: "Dad"},
    {id: "mom", label: "Mom"},
    {id: "son", label: "Son"},
    {id: "daughter", label: "Daughter"},
    {id: "grandpa", label: "Grandpa"},
    {id: "grandma", label: "Grandma"},
    {id: "brother", label: "Brother"},
    {id: "sister", label: "Sister"},
    {id: "partner", label: "Partner"},
    {id: "guardian", label: "Guardian"},
    // Team / small-business roles (a circle isn't always a family).
    {id: "owner_role", label: "Owner"},
    {id: "lead", label: "Lead"},
    {id: "manager", label: "Manager"},
    {id: "driver", label: "Driver"},
    {id: "other", label: "Other"},
];

const STORAGE_KEY = "circle_relationship";

export function getSavedRelationship() {
    try {
        return localStorage.getItem(STORAGE_KEY) || null;
    } catch (e) {
        return null;
    }
}

export function saveRelationship(id) {
    try {
        if (id) {
            localStorage.setItem(STORAGE_KEY, id);
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        // storage unavailable (private mode); relationship is best-effort
    }
}

export function relationshipLabel(id) {
    return RELATIONSHIPS.find((r) => r.id === id)?.label ?? null;
}
